// extracted by mini-css-extract-plugin
export var audioPlayer = "_kh-0";